import { graphql } from "api/cms-website/generated";

export const QuestionsWithImageFragment = graphql(/* GraphQL */ `
    fragment QuestionsWithImageFragment on ComponentComponentsQuestionsWithImage {
        id
        noMarginBottom
        ctaTestId
        questionsWithImageTitle: title
        image {
            ...ResponsiveImageFragment
        }
        questionsWithImageCta: cta {
            ...ButtonFragment
        }
        questions {
            ...QuestionsWithImageContentFragment
        }
    }
`);
